import Klass from '@/models/Klass';
import ScheduledLesson from '@/models/ScheduledLesson';
import User from '@/models/User';

export interface KlassScopePermissionParams {
  user?: User;
  klass?: Klass;
  scheduledLesson?: ScheduledLesson;
}

export default class KlassScopePermission {
  user?: User;
  klass?: Klass;
  scheduledLesson?: ScheduledLesson;

  constructor({
    user,
    klass,
    scheduledLesson,
  }: KlassScopePermissionParams = {}) {
    this.user = user;
    this.klass = klass;
    this.scheduledLesson = scheduledLesson;
  }

  isFromUnitKlass(): boolean {
    if (!this.klass || !this.user) return false;
    return this.user.unitsIds.includes(this.klass.unitId);
  }

  isTeacherInKlass(): boolean {
    if (!this.klass || !this.user) return false;
    return (
      this.klass.teacherId === this.user.id ||
      this.user.id === this.scheduledLesson?.teacher
    );
  }
}
